import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatDate(dateStr) {
  const date = new Date(dateStr);

  const month = date
    .toLocaleString("default", { month: "short" })
    .toUpperCase();

  const day = date.getDate();
  const year = date.getFullYear();

  return { month, day, year };
}

function OtherNewsSection({ datacontent, initialPagination, id, type }) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [loading, setLoading] = useState(false);
  const headerTitle =
    datacontent[0]?.title.length > 0 ? datacontent[0]?.title : "News & Media";

  useEffect(() => {
    setNewsList(datacontent || []);

    setSelectedNews(datacontent?.[0] || null);
  }, [datacontent]);

  useEffect(() => {
    //if (page === 1) return;

    fetchNews();
  }, [page]);

  const fetchNews = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        type === 1
          ? `${BASE_URL}posdata?pageName[eq]=${id}&columes[eq]=title_show_echo_02&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&display01[eq]=1&page=${page}&per_page=4`
          : `${BASE_URL}news-media?pageName[eq]=1&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&columes[in]=title_show_echo_01zz,title_show_echo_02,title_show_echo_03,title_show_echo_01zz&page=${page}&per_page=8`,
      );

      const allData = response?.data?.allData || [];
      console.log("$$$333", type);
      setNewsList(allData);

      // auto select first news
      setSelectedNews(allData[0] || null);

      setPagination(
        response?.data?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const { month, day, year } = selectedNews?.daterqw
    ? formatDate(selectedNews.daterqw)
    : { month: "", day: "", year: "" };

  if (!selectedNews) return null;

  return (
    <section id="services" className="services section light-background ">
      <div className="container section-title" data-aos="fade-up">
        {/* <h2>OTHER NEWS</h2> */}
        <p>
          {/* <span>News </span> */}
          <span className="description-title">{headerTitle}</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {newsList.map((item, index) => {
            const date = new Date(item.daterqw);

            const month = date
              .toLocaleString("default", { month: "short" })
              .toUpperCase();

            const day = date.getDate();
            const year = date.getFullYear();

            return (
              <div
                className="col-lg-3 col-md-4"
                data-aos="fade-up"
                data-aos-delay={100 + index * 100}
                key={item.id || index}
              >
                <div className="card h-100 shadow border-0">
                  {item.passport && (
                    <>
                      <div className="position-relative mb-2">
                        {item.passport &&
                          item.passport !== "undefined" &&
                          item.passport !== "null" &&
                          item.passport.trim() !== "" && (
                            <>
                              <img
                                loading="lazy"
                                decoding="async"
                                src={`${BACKEND_URL}upload/${item.passport}`}
                                alt={item.title || "Image"}
                                className="card-img-top rounded-0"
                                style={{
                                  objectFit: "cover",
                                  height: type === 1 ? "200px" : "300px",
                                }}
                              />
                            </>
                          )}
                        <div className="vertical-date-badge">
                          <div className="date-part">{month}</div>
                          <div className="date-divider">—</div>
                          <div className="date-part vertical-formatDate">
                            {day}
                          </div>
                          <div className="date-divider">—</div>
                          <div className="date-part">{year}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="card-body d-flex flex-column">
                    {item.caption && (
                      <small className="text-muted mb-0 blockquote-footer text-secondary">
                        <em>
                          <HTMLDisplay
                            html={item.caption}
                            textNo={10}
                            type="title"
                            textSize="0.8rem"
                          />
                        </em>
                      </small>
                    )}

                    <span
                      className="card-title text-capitalize pt-2 text-secondary"
                      style={{ textAlign: "justify" }}
                    >
                      <HTMLDisplay
                        html={item.story01}
                        textNo={10}
                        type="title"
                      />
                    </span>
                    <p
                      className="card-text text-secondary limited-text"
                      style={{ flexGrow: 1 }}
                    >
                      <HTMLDisplay
                        html={item.story01}
                        textNo={60}
                        type="body"
                      />
                    </p>
                    <Link
                      to={`/read/${item.id}`}
                      className="read-more-link btn btn-iceberg mt-0 text-start text-start"
                    >
                      Read More →
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Pagination Controls */}
        <div className="d-flex justify-content-end align-items-center mt-3">
          <button
            className="btn btn-dark me-2"
            onClick={() => setPage(1)}
            disabled={pagination?.current_page === 1}
          >
            «
          </button>

          <button
            className="btn btn-dark me-2"
            onClick={() => setPage(pagination?.current_page - 1)}
            disabled={pagination?.current_page === 1}
          >
            ‹
          </button>

          <span className="me-2">
            Page {pagination?.current_page} of {pagination?.last_page}
          </span>

          <button
            className="btn btn-dark me-2"
            onClick={() => setPage(pagination?.current_page + 1)}
            disabled={pagination?.current_page === pagination?.last_page}
          >
            ›
          </button>

          <button
            className="btn btn-dark"
            onClick={() => setPage(pagination?.last_page)}
            disabled={pagination?.current_page === pagination?.last_page}
          >
            »
          </button>
        </div>
      </div>
    </section>
  );
}

export default React.memo(OtherNewsSection);
